import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { introductionBannerState } from './reducer';

export const getErrors = (state: RootState) => state.generalContents.errors;

export const getIntroductionBanner = (state: RootState) => state.introductionBanner;

export const getItem = createSelector(
  getIntroductionBanner,
  (state: introductionBannerState) => state.item,
);

export const getIsFetching = createSelector(
  getIntroductionBanner,
  (state: introductionBannerState) => state.isFetching,
);
